// extracted by mini-css-extract-plugin
export default {"feElement":"style_feElement__cKw3W","feElementName":"style_feElementName__U+Hh+"};